
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zM7.29 14.48a4.821 4.821 0 012.23 2.23.51.51 0 00.92 0 4.821 4.821 0 012.23-2.23A.51.51 0 0013 14a.51.51 0 00-.29-.44 4.804 4.804 0 01-2.22-2.21.54.54 0 00-1 0 4.804 4.804 0 01-2.22 2.21A.51.51 0 007 14a.51.51 0 00.29.48zm5.9-5.16c.65.315 1.175.84 1.49 1.49A.34.34 0 0015 11c.126 0 .24-.07.3-.18a3.168 3.168 0 011.49-1.49A.34.34 0 0017 9c0-.126-.07-.24-.18-.3a3.189 3.189 0 01-1.49-1.5A.38.38 0 0015 7a.38.38 0 00-.33.2 3.171 3.171 0 01-1.48 1.48A.3.3 0 0013 9a.3.3 0 00.19.32z"}})])
          )
        }
      }
    